import { Form } from 'react-bootstrap'
import { FormattedMessage, useIntl } from 'react-intl'
import { observer } from 'mobx-react'

import { Label } from 'Components/_theme'

import { useCountryList } from 'Portal/src/hooks'

import { LegacyCountrySelectProps } from './LegacyCountrySelect.types'

export const LegacyCountrySelect = observer(
  (props: LegacyCountrySelectProps) => {
    const { disabled, controlId, defaultValue, value, handleOnChange } = props
    const intl = useIntl()
    const countryList = useCountryList()

    return (
      <Form.Group className="mb-2" controlId={controlId}>
        <Label htmlFor={controlId}>
          <FormattedMessage id="Country" /> *
        </Label>

        <Form.Select
          defaultValue={defaultValue}
          disabled={disabled}
          name={controlId}
          onChange={handleOnChange}
          value={value}
        >
          <option value="">
            {intl.formatMessage({ id: 'Select_country' })}
          </option>

          {Object.keys(countryList).map(isoCode => (
            <option key={isoCode} value={isoCode}>
              {countryList[isoCode]}
            </option>
          ))}
        </Form.Select>

        <Form.Control.Feedback type="invalid">
          <FormattedMessage id="Field_invalid" />
        </Form.Control.Feedback>
      </Form.Group>
    )
  },
)
